import es from "./es";
import en from "./en";

const locales = { en, es };

export default locales;
